// extracted by mini-css-extract-plugin
export default {"main":"Home_main__rNDdh","mainWrapper":"Home_mainWrapper__C-kk1","mainContainer":"Home_mainContainer__OD0jx","hamburgerMenu":"Home_hamburgerMenu__fwT3M"};